<div class="form-group" *ngIf="!(removeCtrl$ | async)" [hidden]="isHidden$ | async"><field-generator *ngFor="let field of group.fields" [field]="field"></field-generator></div>
